// services/userService.ts
import api from "./api";

export interface ProfileData {
  first_name: string;
  last_name: string;
  country?: string;
}

const userService = {
  getProfile: async () => {
    const response = await api.get("/profile");
    return response.data;
  },

  submitKYC: async (formData: FormData) => {
    try {
      console.log("Submitting KYC with FormData...");

      const entries = Array.from(formData.entries());
      console.log("FormData entries:", entries.length);

      entries.forEach((pair) => {
        console.log(
          `${pair[0]}:`,
          pair[1] instanceof File
            ? `${pair[1].name} (${pair[1].type})`
            : pair[1],
        );
      });

      const response = await api.post("/kyc/submit", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 60000,
      });

      console.log("KYC submission response:", response.data);
      return response.data;
    } catch (error: any) {
      console.error("KYC submission error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });

      if (error.code === "ECONNABORTED") {
        throw new Error(
          "Request timeout. Please check your internet connection and try again.",
        );
      }

      if (!error.response) {
        throw new Error(
          "Network error. Please check your internet connection.",
        );
      }

      if (error.response?.status === 422) {
        const errors = error.response.data?.errors;
        if (errors) {
          const errorMessages = Object.values(errors).flat().join(", ");
          throw new Error(`Validation failed: ${errorMessages}`);
        }
      }

      throw new Error(
        error.response?.data?.message || "Failed to submit KYC documents",
      );
    }
  },

  getKYCStatus: async () => {
    try {
      const response = await api.get("/kyc/status");
      return response.data;
    } catch (error: any) {
      console.error("Failed to fetch KYC status:", error);
      return { kyc_status: null, submitted: false };
    }
  },

  updateProfile: async (profileData: ProfileData) => {
    const response = await api.put("/profile", profileData);
    return response.data;
  },
};

export default userService;
